import React from 'react';
import RealisationsHero from '../components/realisations/RealisationsHero/RealisationsHero';
import Button from '../components/common/Button/Button';
import styles from './NotreCooperative.module.css'; // Créez ce fichier de style

function NotreCooperative() {
  return (
    <>
      <RealisationsHero
        title="La Coopérative Les Bâtisseurs Unis"
        subtitle="Un groupement d'artisans tous corps d'état, partenaires de confiance pour réaliser votre bâtiment de A à Z."
        backgroundImage="/images/pergola.jpg" // Make sure this image exists
      >
        <Button to="/contact" variant="primary">Contactez-nous</Button>
      </RealisationsHero>
      <section className="section">
        <div className="container">
          <div className={styles.introSection}>
            <div className={styles.introContent}>
              <div className={styles.introText}>
                <span className={styles.eyebrow}>Notre Modèle</span>
                <h2 className={styles.title}>L'union fait la force de votre projet</h2>
                <div className={styles.divider}></div>
                <p className={styles.description}>
                  Maison Quinard est fière de faire partie de la coopérative <strong>Les Bâtisseurs Unis</strong>. Ce n'est pas une simple entreprise, c'est une véritable alliance de partenaires artisans réunis autour d'un objectif commun : réaliser votre bâtiment avec un haut niveau d'exigence.
                </p>
                <div className={styles.highlightNotice}>
                  <p>En tant que groupement "tous corps d'état", nous mutualisons nos compétences pour vous offrir une solution globale et parfaitement coordonnée.</p>
                </div>
              </div>
              <div className={styles.introImageWrapper}>
                <div className={styles.imageCard}>
                  <img src="/images/interieur.jpg" alt="Intérieur bois chaleureux" className={styles.mainImage} />
                  <div className={styles.statBadge}>
                    <span className={styles.badgeLabel}>SCOP</span>
                    <span className={styles.badgeText}>Modèle Engagé</span>
                  </div>
                </div>
                <div className={styles.imageDecoration}></div>
              </div>
            </div>
          </div>

          <div className={styles.definitionSection}>
            <div className={styles.definitionContent}>
              <div className={styles.definitionImageWrapper}>
                <div className={styles.imageCard}>
                  <img src="/images/logo.jpg" alt="Travail d'équipe coopératif" className={styles.mainImage} />
                </div>
                <div className={styles.imageDecoration}></div>
              </div>
              <div className={styles.definitionText}>
                <span className={styles.eyebrow}>Définition</span>
                <h2 className={styles.title}>Qu'est-ce qu'une Coopérative ?</h2>
                <div className={styles.divider}></div>
                <p className={styles.description}>
                  Une coopérative artisanale comme <strong>Les Bâtisseurs Unis</strong> est un groupement d'entreprises indépendantes (maçons, charpentiers, électriciens, plombiers...) qui décident de s'allier. Chez Maison Quinard, nous sommes les spécialistes du bois au sein de ce groupement.
                </p>
                <p className={styles.textHighlight}>
                  Des artisans partenaires qui s'unissent pour la réussite totale de votre construction.
                </p>
                <p className={styles.description}>
                  Contrairement à la sous-traitance classique, cette alliance vous garantit un interlocuteur unique et une cohésion parfaite sur le chantier. La coopérative <strong>Les Bâtisseurs Unis</strong> gère et coordonne l'ensemble des corps d'état nécessaires pour vous livrer un bâtiment clé en main.
                </p>
              </div>
            </div>
          </div>

          <div className={styles.valuesSection}>
            <div className={styles.sectionHeader}>
              <span className={styles.eyebrow}>Nos Piliers</span>
              <h2 className={styles.title}>Pourquoi ce Modèle ?</h2>
              <div className={styles.divider}></div>
            </div>

            <div className={styles.valuesGrid}>
              <div className={styles.valueCard}>
                <span className={styles.valueIcon}>🤝</span>
                <h4>Partenaires Associés</h4>
                <p>Pas de lien de subordination ni de sous-traitance subie. Nos artisans sont liés par une confiance solide et la passion du travail bien fait.</p>
              </div>
              <div className={styles.valueCard}>
                <span className={styles.valueIcon}>🏗️</span>
                <h4>Tous Corps d'État</h4>
                <p>Du terrassement à la couverture, de la plomberie aux finitions intérieures : nous rassemblons tous les métiers indispensables à votre construction.</p>
              </div>
              <div className={styles.valueCard}>
                <span className={styles.valueIcon}>⏱️</span>
                <h4>Coordination Absolue</h4>
                <p>Les plannings sont optimisés. Puisque nous avons l'habitude de travailler ensemble, les délais sont raccourcis et tenus sans temps morts.</p>
              </div>
              <div className={styles.valueCard}>
                <span className={styles.valueIcon}>⭐</span>
                <h4>Qualité Exceptionnelle</h4>
                <p>L'implication directe de chaque patron d'entreprise garantit un soin méticuleux, car notre réputation commune est engagée à chaque nouveau projet.</p>
              </div>
            </div>
          </div>

          <div className={styles.missionSection}>
            <div className={styles.missionCard}>
              <span className={styles.eyebrow}>La Garantie Bâtisseurs Unis</span>
              <h2 className={styles.title}>Un seul réseau pour l'ensemble de votre chantier</h2>
              <div className={styles.divider}></div>
              <p className={styles.description}>
                En faisant appel à Maison Quinard, vous débloquez immédiatement l'accès au réseau complet des <strong>Bâtisseurs Unis</strong>. Vous n'avez plus à chercher vos artisans (électricien, plombier, couvreur, plaquiste...) un par un. Nous vous mettons en relation avec nos partenaires de confiance formés à travailler ensemble depuis des années. Vous bénéficiez d'une synergie rare sur les chantiers.
              </p>
            </div>
          </div>

          <div className={styles.finalCTA}>
            <div className={styles.ctaCard}>
              <div className={styles.ctaContent}>
                <span className={styles.eyebrow}>Un projet complet ?</span>
                <h3 className={styles.ctaTitle}>Rencontrez la Coopérative</h3>
                <div className={styles.ctaDivider}></div>
                <p className={styles.ctaDescription}>Faites confiance à l'alliance des <strong>Bâtisseurs Unis</strong> pour une réalisation sereine, de l'ossature bois jusqu'aux dernières finitions.</p>
                <div className={styles.ctaButtonWrapper}>
                  <Button to="/contact" variant="primary" size="large">Discuter de mon projet</Button>
                </div>
              </div>
              <div className={styles.ctaDecoration}></div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default NotreCooperative;
